import { getWalletIcon, walletList, zkLoginList } from '@constants/wallet-list';
import { walletConnectModel } from '@models/wallet-connect.model';
import { useConnectWallet, useDisconnectWallet, useWallets } from '@mysten/dapp-kit';
import { useModel } from 'foca';
import { type FC } from 'react';
import CoinLogo from '@ui/coin-logo';
import styles from './wallet-dialog.module.scss';
import Dialog from '@ui/parrot/dialog';
import ParrotDrawer from '@ui/parrot/drawer';
import { useWindowSize } from 'react-use';
import { notification } from 'antd';

const WalletDialog: FC = () => {
  const { width } = useWindowSize();
  const showDialog = useModel(walletConnectModel, (state) => state.openDialog);

  return (
    <>
      {width > 640 ? (
        <Dialog
          isShown={showDialog}
          width={360}
          title="Connect a Wallet"
          onCloseComplete={walletConnectModel.toggleDialog}
        >
          {({ close }: { close: () => void }) => <WalletDialogContent close={close} />}
        </Dialog>
      ) : (
        <ParrotDrawer
          title="Connect a Wallet"
          onClose={walletConnectModel.toggleDialog}
          open={showDialog}
          closable={true}
        >
          <WalletDialogContent close={walletConnectModel.toggleDialog} />
        </ParrotDrawer>
      )}
    </>
  );
};

const WalletDialogContent: FC<{ close: () => void }> = ({ close }) => {
  const wallets = useWallets();
  const { mutate: connect } = useConnectWallet();
  const { mutate: disconnect } = useDisconnectWallet();

  return (
    <div className={styles.wallet_list}>
      <div className={styles.wallet_right}>
        <ul>
          {zkLoginList
            .filter((item) => !item.hidden)
            .map((item) => {
              const wallet = wallets.find((wallet) => wallet.name === item.walletName);
              return (
                <li
                  key={item.label}
                  onClick={() => {
                    walletConnectModel.toggleDialog();
                    if (wallet) {
                      disconnect();
                      connect({
                        wallet,
                      });
                    } else {
                      notification.open({
                        message: 'Wallet is not ready, please install extension first',
                      });
                    }
                  }}
                >
                  <div className={styles.list}>
                    <div className={styles.icon}>
                      <CoinLogo src={getWalletIcon(item.iconName)} />
                    </div>
                    <span>{item.label}</span>
                  </div>
                </li>
              );
            })}
        </ul>
      </div>

      <div className={styles.wallet_left}>
        <ul>
          {walletList
            .filter((item) => !item.hidden)
            .map((item) => {
              const wallet = wallets.find((wallet) => wallet.name === item.walletName);
              return (
                <li
                  key={item.walletName}
                  onClick={() => {
                    close();
                    if (wallet) {
                      disconnect();
                      connect({
                        wallet,
                      });
                    } else {
                      notification.open({
                        message: (
                          <div className={styles.wallet_tip}>
                            Wallet is not ready, please install&nbsp;
                            <a href={item.chromeExtension} target="_blank">
                              {item.walletName}
                            </a>{' '}
                            extension first
                          </div>
                        ),
                      });
                    }
                  }}
                >
                  <CoinLogo src={getWalletIcon(item.iconName) || wallet?.icon} />
                  <span>{item.label}</span>
                  {wallet ? null : 'Install'}
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default WalletDialog;
